import { writable } from 'svelte/store'

export const clipboardData = writable([])
export const errorState = writable(false)
export const keepLogin = writable(false)
export const errorMessage = writable('')
export const username = writable('')
export const basicAuth = writable('')
export const bearerToken = writable({})
